import { ElementViewTemplate, html, ref } from "@microsoft/fast-element";
import { NatGenAccordionItem } from "./accordion-item";
import { AccordionItemOptions } from "./accordion-item.options";
import { endSlotTemplate, startSlotTemplate } from "../start-end/start-end";
import { staticallyCompose } from "../../foundation/template-helpers";

/**
 * The template for the {@link @microsoft/fast-foundation#(FASTAccordionItem:class)} component.
 * @public
 */
export function accordionItemTemplate<T extends NatGenAccordionItem>(
    options: AccordionItemOptions = {}
): ElementViewTemplate<T> {
    return html<T>`
        <div
            class="heading"
            part="heading"
            role="heading"
            aria-level="${x => x.headinglevel}"
        >
            <button
                class="button"
                part="button"
                ${ref("expandbutton")}
                ?disabled="${x => (x.disabled ? "true" : void 0)}"
                aria-expanded="${x => x.expanded}"
                aria-controls="${x => x.id}-region"
                id="${x => x.id}"
                @click="${(x, c) => x.clickHandler(c.event as MouseEvent)}"
            >
                <span class="heading-content" part="heading-content">
                    <slot name="heading"></slot>
                </span>
            </button>
            ${
                /* The start slot is after the button for an improved screen reader experience */ ""
            }
            ${startSlotTemplate(options)}
            ${endSlotTemplate(options)}
            <span class="expand-collapse-icon" part="expand-collapse-icon" aria-hidden="true">
                <slot name="expanded-icon">
                    ${staticallyCompose(options.expandedIcon)}
                </slot>
                <slot name="collapsed-icon">
                    ${staticallyCompose(options.collapsedIcon)}
                </slot>
            <span>
        </div>
        <div
            class="region"
            part="reqion"
            id="${x => x.id}-reqion"
            role="region"
            aria-labelledby="${x => x.id}"
        >
            <slot></slot>
        </div>
`;
}
